import {IntermediatePart} from "../../intermediatePart";

export default class CenterIslandShadow extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_shadow';
    this.partName = 'Center Island Shadow';
    this.visible = false;
  }

  load(dbFeature) {
    dbFeature.metaData["RoomLayout"] = (dbFeature.metaData["RoomLayout"] && dbFeature.metaData["RoomLayout"].filter(roomLayout => roomLayout.includes("I"))) || [];
    return super.load_(dbFeature, new CenterIslandShadow());
  }

  setLayers(layout) {

    const cabinet = this.getParent().cabinet;
    if (cabinet && (cabinet.disabled || !cabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    const cabinetType = this.getParent().getCabinetType();
    return [{
      propName: "Cabinet",
      propValue: cabinetType
    }, {
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.CenterIsland.CenterIslandShadow;
    }
  }
}